import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import { AdvanceIdeaStatusAlert } from "./AdvanceIdeaStatusAlert";
import { Features } from "./features";
import { GameQuickLinks } from "./GameQuickLinks";
import { StatusDropDown } from "./StatusDropDown";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId} props.gameId
 * @param {import("@seabrookstudios/pitch2table-core").DesignerGameStatus} props.status
 * @param {(status: import("@seabrookstudios/pitch2table-core").DesignerGameStatus) => void} props.onChange
 */
export const GameStatusCard = ({ gameId, status, onChange }) => (
  <Card elevation={1} square={false}>
    {!Features.BaseCampLayout && <GameQuickLinks />}
    <Box p={1}>
      <AdvanceIdeaStatusAlert gameId={gameId} status={status} onChange={onChange} />
      <StatusDropDown value={status} onChange={onChange} />
    </Box>
  </Card>
);
